import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'

export const ExtensionErrorGuideTooltip = (props: any) => {
  const { setOpenExtensionErrorGuideTooltip } = props

  const handleModal = () => {
    setOpenExtensionErrorGuideTooltip((prev: boolean) => !prev)
  }

  const handleMoveLink = (url: string) => {
    if (url) {
      window.open(url, '_blank')
    }
  }

  return (
    <div
      className={classNames(
        'flex flex-col p-[16px] md:p-6 gap-[10px] bg-white    absolute border-[3px] border-main  rounded-[20px] ',
        {
          'w-[341px] bottom-8 right-0': !isMobile,
          'w-[341px] bottom-5 -left-32': isMobile,
        }
      )}
    >
      <p className=" md:leading-[19.2px] md:text-base  leading-[12px] text-[10px] flex justify-between items-center">
        <span className="font-bold text-[18px]">확장프로그램 오류발생!</span>
        <button className="" type="button" onClick={handleModal}>
          <img
            src="assets/img/Icon_x.png"
            alt="icon_x"
            height={24}
            width={24}
          />
        </button>
      </p>
      <p className="font-bold">
        다른 사용자분들은 아래 방법으로 100% 문제를 해결하셨습니다.
        <br />꼭 순서대로 시도해 주세요!
        <br />
        <span className="font-normal">
          (※ 한 단계씩만 따라 하셔도 증상이 해결되는 경우가 많습니다)
        </span>
      </p>
      <div className="px-2 py-4 bg-[#EEF1F7] rounded-[10px]">
        <ul className=" list-decimal text-error ml-3">
          <li className="">
            <span className="text-error">
              필요 없는 크롬 확장 프로그램을 비활성화 또는 삭제
            </span>
            <span className="text-[#2E343D]">
              해 주세요. <br />
              특히, 기존에 설치된 '패스트링크' 확장 프로그램은 반드시 삭제해
              주세요. <br />
              (동시에 사용 시 충돌이 발생할 수 있습니다.) 
            </span>
          </li>
          <li>
            <span className="text-[#2E343D]">
              패스트컷AI 웹사이트 및 확장 프로그램{' '}
            </span>
            모두에서 로그아웃 후 다시 로그인
            <span className="text-[#2E343D]">해 주세요.</span>
          </li>
          <li>
            {' '}
            <span className="text-[#2E343D]">컴퓨터를</span> 재부팅
            <span className="text-[#2E343D]">한 뒤 다시 실행해 주세요.</span>
          </li>
        </ul>
      </div>
      <p>
        위 세 가지 방법을 모두 시도했지만 그래도 문제가 지속된다면, 어떤
        증상인지 캡처와 함께 알려주시면 빠르게 도와드릴게요! 😊
      </p>
    </div>
  )
}
